import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Review from '../components/review';
import '../css/Home.css';
import '../css/Service.css';

const CompliantHazardousWaste = () => {
  const [previewSrc, setPreviewSrc] = useState(null);

  const showPreview = (src) => {
    setPreviewSrc(src);
  };

  const hidePreview = () => {
    setPreviewSrc(null);
  };

  return (
    <div className="service-page">
      {previewSrc && (
        <div
          onClick={hidePreview}
          onMouseLeave={hidePreview}
          role="button"
          tabIndex={0}
          style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.7)',
            zIndex: 2000,
            cursor: 'zoom-out'
          }}
        >
          <img
            src={previewSrc}
            alt="Preview"
            style={{ maxWidth: '92%', maxHeight: '92%', boxShadow: '0 6px 30px rgba(0,0,0,0.6)' }}
          />
        </div>
      )}
      <div className="service-banner">
        <img src="/img_2.jpg" alt="Compliant Hazardous Waste Banner" className="service-banner-img" onMouseEnter={() => showPreview('/img_2.jpg')} onClick={() => showPreview('/img_2.jpg')} />
        <div className="service-banner-overlay"></div>
        <div className="service-banner-content">
          <h1>Compliant Hazardous Waste Solutions</h1>
        </div>
      </div>

      <header className="service-header">
        <h1>COMPLIANT HAZARDOUS WASTE SOLUTIONS</h1>
        <p>Secure medical and hazardous waste management with advanced incineration and proven safety protocols.</p>
      </header>

      <section className="service-content">
        <div className="service-content-left">
          <h2>Our Waste Treatment Operations</h2>

          <h3>Incinerator Operations</h3>
          <p className="lead">
            Our trained operational staff manage the controlled burning of medical and hazardous waste using high-temperature incineration systems. This process ensures complete destruction of infectious materials, chemical contaminants, and harmful substances while maintaining strict safety standards.
          </p>
          <p>
            Incineration is performed in multi-chamber furnaces with precise temperature and residence-time controls to guarantee complete thermal destruction of hazardous constituents.
          </p>
          <p>
            Exhaust gases pass through an emissions-treatment train — including cyclones, scrubbers, and high-efficiency particulate filters — and are continuously monitored to comply with local and national air-quality regulations.
          </p>
          <p>
            All incoming wastes are pre-screened, segregated, and packaged to prevent chemical interactions and to optimise combustion efficiency and throughput.
          </p>
          <p>
            Operators follow strict SOPs, wear certified personal protective equipment, and undergo recurrent training and competency assessments to maintain operational excellence.
          </p>
          

<div style={{marginTop: '80px'}}></div>
          <h3 className="mt-4">Yellow Room – Hazardous Waste Storage</h3>
          <p>
            All medical and hazardous waste is securely stored in our Yellow Room prior to incineration. The storage area is maintained under controlled conditions and prepared for high-temperature destruction at 850–1100°C, a range proven to eliminate pathogens and prevent the formation of harmful microorganisms.
          </p>

<div style={{marginTop: '120px'}}></div>
          <h3 className="mt-4">Ash Room – Post-Incineration Handling</h3>
          <p>
            After complete combustion, residual ash is transferred to our designated Ash Room. This area is used for the safe containment and handling of treated waste remnants, ensuring environmentally responsible final disposal in accordance with regulatory guidelines.
          </p>

          <div className="service-cta mt-3">
            <a href="/contact" className="btn btn-primary">Contact Us</a>
          </div>
        </div>

        <aside className="service-content-right">
          <div className="image-pair" style={{ marginBottom: '1rem' }}>
            <img src="/incinerator_operations_waste_buring_staff_02.jpeg" alt="Incinerator staff 2" style={{ width: '100%', height: '280px', objectFit: 'cover', marginBottom: '0.5rem', cursor: 'zoom-in' }} onMouseEnter={() => showPreview('/incinerator_operations_waste_buring_staff_02.jpeg')} onClick={() => showPreview('/incinerator_operations_waste_buring_staff_02.jpeg')} />
            <img src="/incinerator_operations_waste_buring_staff_01.jpeg" alt="Incinerator staff 1" style={{ width: '100%', height: '280px', objectFit: 'cover', marginBottom: '0.5rem', cursor: 'zoom-in' }} onMouseEnter={() => showPreview('/incinerator_operations_waste_buring_staff_01.jpeg')} onClick={() => showPreview('/incinerator_operations_waste_buring_staff_01.jpeg')} />
            <img src="/yellow_room.jpeg" alt="Yellow Room" style={{ width: '100%', height: '260px', objectFit: 'cover', marginBottom: '0.5rem', cursor: 'zoom-in' }} onMouseEnter={() => showPreview('/yellow_room.jpeg')} onClick={() => showPreview('/yellow_room.jpeg')} />
            <img src="/ash_room.jpeg" alt="Ash Room" style={{ width: '100%', height: '260px', objectFit: 'cover', cursor: 'zoom-in' }} onMouseEnter={() => showPreview('/ash_room.jpeg')} onClick={() => showPreview('/ash_room.jpeg')} />
          </div>

          <div className="specialty-card">
            <h3>Why Choose Clean World</h3>
            <ul className="specialty-list">
              <li>Regulatory-compliant handling and transport</li>
              <li>Documented chain-of-custody and reporting</li>
              <li>High-temperature incineration (850–1100°C)</li>
              <li>Trained operational and safety personnel</li>
            </ul>
          </div>
        </aside>
      </section>
      <Review />
    </div>
  );
};

export default CompliantHazardousWaste;
